// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"539":"18d6a327","856":"a91251d7","993":"5489ba1b"}[chunkId] + ".chunk.css";
};